import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-invalid-link-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogModule],
  template: `
    <div class="invalid-wrapper">
      <mat-icon class="invalid-icon">error</mat-icon>
      <h2 class="title">Datos incorrectos en el link</h2>
      <p class="subtitle">
        Por favor verifica que el enlace de pago sea válido o contacta soporte.
      </p>
    </div>
  `,
  styles: [
    `
      .invalid-wrapper {
        text-align: center;
        padding: 24px 20px 12px;
        max-width: 340px;
      }
      .invalid-icon {
        font-size: 72px;
        width: 72px;
        height: 72px;
        color: #c62828;
        margin-bottom: 12px;
      }
      .title {
        margin: 0 0 8px;
        font-size: 20px;
        font-weight: 600;
        color: #c62828;
      }
      .subtitle {
        margin: 0 0 20px;
        font-size: 14px;
        color: #444;
      }
      button {
        min-width: 140px;
      }
    `,
  ],
})
export class InvalidLinkDialogComponent {
  constructor(private dialogRef: MatDialogRef<InvalidLinkDialogComponent>) {}
  close() {
    this.dialogRef.close();
  }
}
